
import { BASE_URL } from "../../global";
import axiosWithToken from "../../utils/components/axiosTokenConfig";

const isOffLine = localStorage.getItem("isOffLine") === "true";

// api calls
export const checkDSStatusByCount = (setDBStatus) => {
  let srfInstrumentsQuery = { query: `SELECT MIN(id) AS min_of_id, MAX(id) AS max_of_id, AVG(id) AS avg_of_id, SUM(id) AS sum_of_id, STDDEV(id) AS stddev_of_id, VARIANCE(id) AS variance_of_id FROM srfInstruments;` };

let certificatesQuery = { query: `SELECT MIN(id) AS min_of_id, MAX(id) AS max_of_id, AVG(id) AS avg_of_id, SUM(id) AS sum_of_id, STDDEV(id) AS stddev_of_id, VARIANCE(id) AS variance_of_id FROM certificates;` };

let datasheetsQuery = { query: `SELECT MIN(id) AS min_of_id, MAX(id) AS max_of_id, AVG(id) AS avg_of_id, SUM(id) AS sum_of_id, STDDEV(id) AS stddev_of_id, VARIANCE(id) AS variance_of_id FROM datasheets;` };

  axiosWithToken
    .post(BASE_URL + `dynamic`,datasheetsQuery, {headers:{requestType: 'fetchData'}})
    .then(async (res) => {
      // extract max id of DSs
      let ds_max_id = res.data[0]?.max_of_id;

      axiosWithToken
        .post(BASE_URL + `dynamic`,certificatesQuery, {headers:{requestType: 'fetchData'}})
        .then(async (res) => {
          let cert_max_id = res.data[0]?.max_of_id;
          axiosWithToken
            .post(BASE_URL + `dynamic`,srfInstrumentsQuery, {headers:{requestType: 'fetchData'}})

            .then(async (res) => {
              let srf_ins_max_id = res.data[0]?.max_of_id;
              if(isOffLine){
                  setDBStatus("healthy")
              }else{
              setDBStatus(
                  // ds_max_id == cert_max_id && ds_max_id 
                ds_max_id == cert_max_id && ds_max_id == srf_ins_max_id              
                  ? "healthy"
                  : "sick"
              );
              }             
            })
            .catch((err) => {
              console.log("datasheet data fetching error: ", err);
            });
           if(isOffLine){
                  setDBStatus("healthy")
              }else{
          setDBStatus(res.data[0]?.max_of_id == ds_max_id ? "healthy" : "sick");
              }
        })
        .catch((err) => {
          console.log("datasheet data fetching error: ", err);
        });
    })
    .catch((err) => {
      console.log("datasheet data fetching error: ", err);
    });
};
